export const normalizationMap: Record<string, string> = {
  // CUD fields
  "created at": "created",
  "created on": "created",
  "created date": "created",
  "updated at": "updated",
  "updated on": "updated",
  "updated date": "updated",
  "last updated": "updated",
  "deleted at": "deleted",
  "deleted on": "deleted",
  "deleted date": "deleted",

  // Date fields
  "date of birth": "dob",
  birthday: "dob",
  "birth date": "dob",
  birthdate: "dob",

  // Phone fields
  "phone number": "phone",
  "work phone": "phone",
  "mobile phone": "phone",
  "fax number": "phone",
  "contact number": "phone",
  telephone: "phone",

  // Name fields
  firstname: "first name",
  lastname: "last name",
  "last name": "last name",
  "full name": "first name",
  name: "first name",

  // Address fields
  "street address": "address",
  "shipping address": "address",
  "billing address": "address",
  "postal code": "zipcode",
  "zip code": "zipcode",

  // Email fields
  "email address": "email",
  "work email": "email",
  "personal email": "email",

  // Company fields
  "company name": "company",
  organization: "company",

  // Job fields
  position: "job title",
  role: "job title",
  occupation: "job title",
};
